function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-cta-promo\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.69,13.61H6.77a1.13,1.13,0,0,1,0-2.25h8.92a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.69,20.89H6.77a1.13,1.13,0,0,1,0-2.25h8.92a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.69,28.17H6.77a1.13,1.13,0,0,1,0-2.25h8.92a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.43,5.43,0,0,1-5.42-5.42V9.74A5.43,5.43,0,0,1,6.56,4.32H33.44a5.44,5.44,0,0,1,5.43,5.42V30.26A5.44,5.44,0,0,1,33.44,35.68ZM6.56,6.57A3.18,3.18,0,0,0,3.39,9.74V30.26a3.18,3.18,0,0,0,3.17,3.17H33.44a3.19,3.19,0,0,0,3.18-3.17V9.74a3.19,3.19,0,0,0-3.18-3.17Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20,35.68a1.14,1.14,0,0,1-1.13-1.13V5.45a1.13,1.13,0,1,1,2.25,0v29.1A1.13,1.13,0,0,1,20,35.68Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20,25.83a1.12,1.12,0,0,1-.63-2L23,21.32a4.26,4.26,0,0,1,4.83,0l1.75,1.17a2,2,0,0,0,2.68-.37L36.48,17a1.14,1.14,0,0,1,1.59-.13,1.12,1.12,0,0,1,.13,1.58l-4.26,5.05a4.28,4.28,0,0,1-5.66.79l-1.75-1.17a2,2,0,0,0-2.29,0l-3.61,2.46A1.11,1.11,0,0,1,20,25.83Z",
  fill: "#231f20"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3,19.34a4.47,4.47,0,1,1,4.46-4.47A4.48,4.48,0,0,1,29.3,19.34Zm0-6.68a2.22,2.22,0,1,0,2.21,2.21A2.22,2.22,0,0,0,29.3,12.66Z",
  fill: "#231f20"
});

function SvgCmsCtaPromo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgCmsCtaPromo;